import React, { useEffect } from 'react';
import { ChangePasswordContentStyled } from './change-password-content.styled';
import Form from '../../../../components/shared/form/form';
import ChangePasswordForm from './change-password-form';
import i18n from '../../../../translations/strings';
import { ValidationNewPasswordSchema } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  changePasswordAction,
  changePasswordResetState,
} from '../../../../store/auth/password-change.store';
import { logoutAction } from '../../../../store/auth/logout.store';
import { useModal } from '../../../../components/shared/modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../../../../components/shared/modal-provider/components/modal/modal.constants';
import LinearLoading from '../../../../components/base/loading/linear-loading/linear-loading';
import { SvgImage, SvgType } from '../../../../components/base/svg/svg';

const ChangePasswordContentPage = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();

  const { changePasswordSuccess, loading, error } = useSelector(
    (state: any) => {
      return state.changePassword;
    },
  );

  const handleCloseModal = () => {
    dispatch(changePasswordResetState());
  };

  useEffect(() => {
    if (changePasswordSuccess) {
      dispatch(changePasswordResetState());
      openModal({
        message: i18n.t('registration.changePasswordSuccess'),
        variant: ModalVariant.Success,
        handleCloseModal: () => {
          dispatch(logoutAction());
          navigate('/login', { replace: true });
        },
      });
    }
  }, [changePasswordSuccess]);

  const onSubmit = (data: any) => {
    dispatch(changePasswordAction(data));
  };

  useEffect(() => {
    openModal({
      message: error,
      variant: ModalVariant.Error,
      handleCloseModal: handleCloseModal,
    });
  }, [error]);

  return (
    <ChangePasswordContentStyled.Container container>
      <LinearLoading loading={loading} />
      <ChangePasswordContentStyled.ContainerForm item md={5} xs={12}>
        <ChangePasswordContentStyled.ContainerLogo>
          <SvgImage type={SvgType.LogoCsv} />
        </ChangePasswordContentStyled.ContainerLogo>
        <ChangePasswordContentStyled.Separator />
        <ChangePasswordContentStyled.TextSocial>
          {i18n.t('registration.changePassword')}
        </ChangePasswordContentStyled.TextSocial>
        <ChangePasswordContentStyled.Separator />
        <Form schema={ValidationNewPasswordSchema}>
          <ChangePasswordForm onSubmit={onSubmit} />
        </Form>
      </ChangePasswordContentStyled.ContainerForm>
    </ChangePasswordContentStyled.Container>
  );
};

export default ChangePasswordContentPage;
